import React, { PropsWithChildren, useCallback, useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { DimensionValue, ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { AppText } from "@/components/AppText";
import { Link } from 'expo-router';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import Accordion, { AccordionProps } from 'react-native-collapsible/Accordion';
import { Image } from 'expo-image';

const styles = StyleSheet.create({
  container: {
    padding: 10,
    alignSelf: "center",
  },
  headerWrapper: {
    //flex: 1,
    flexDirection: 'row',
    justifyContent: "space-between",
  },
  itemWrapper: {

  },
  itemDivider: {
    padding: 10,
  },
  icon: {
    width: 16,
    height: 16,
    alignSelf: "center",
  },
  contentWrapper: {
    paddingTop: 10,
    gap: 20,
  },
  headerSelected: {
    fontWeight: "bold",
  },
  headerUnselected: {
  },
});

export interface AccordianSection {
  content?: React.ReactNode,
};

interface Props {
  data: Map<string, AccordianSection>,
  activeSections?: number[] | string[],
  width?: DimensionValue,
  maxWidth?: DimensionValue,
};

// https://github.com/oblador/react-native-collapsible
export function CustomAccordian({
  data,
  activeSections = [],
  width = undefined,
  maxWidth = undefined,
}: Props) : React.ReactNode {
  const [ currentActiveSections, setCurrentActiveSections ] = useState<number[] | string[]>(activeSections);

  const internalOnChange = useCallback((indexes: number[]) => {
    setCurrentActiveSections(indexes);
  }, []);

  const internalRenderHeader = useCallback((
      content: string,
      index: number,
      isActive: boolean,
      sections: string[],
    ) : React.ReactElement<{}> => {
    return (
      <View style={styles.headerWrapper}>
        <AppText style={isActive ? styles.headerSelected : styles.headerUnselected}>{content}</AppText>
        <Image style={styles.icon} source={isActive ? require("@/assets/images/PixelarticonsChevronUp16x16.png") : require("@/assets/images/PixelarticonsChevronDown16x16.png")} />
      </View>
    );
  }, []);

  const internalRenderContent = useCallback((
      content: string,
      index: number,
      isActive: boolean,
      sections: string[],
    ) : React.ReactElement<{}> => {
    return (
      <View style={styles.contentWrapper}>
        {data.get(content)?.content}
      </View>
    );
  }, []);

  const internalRenderFooter = useCallback((
      content: string,
      index: number,
      isActive: boolean,
      sections: string[],
    ) : React.ReactElement<{}> => {
    if (index == data.size - 1) {
      return <></>;
    }
    return (
      <View style={styles.itemDivider} />
    );
  }, []);

  const internalRenderSectionTitle = useCallback((
      content: string,
      index: number,
      isActive: boolean,
      sections: string[],
    ) : React.ReactElement<{}> => {
    return (
      <></>
    );
  }, []);

  return (
    <Accordion
      sections={[...data.keys()]}
      activeSections={currentActiveSections}
      onChange={internalOnChange}
      renderHeader={internalRenderHeader}
      renderContent={internalRenderContent}
      renderFooter={internalRenderFooter}
      renderSectionTitle={internalRenderSectionTitle}
      underlayColor="transparent"
      containerStyle={[styles.container, { width: width, maxWidth: maxWidth }]}
    />
  );
};
